module.exports = __webpack_public_path__ + "img/menu_btn.f7add6a9.png";